import { CardDesignTokens } from '@primeuix/themes/types/card';

export const Card: CardDesignTokens = {
  root: {
    shadow: 'none',
  },
  title: {
    fontWeight: 'bold',
  },
  body: {
    padding: '0.635rem 1rem',
  },
  css: () => `
    .p-card {
      border: 1px solid var(--p-green-300);
      text-align: start;

      .p-card-title {
        color: var(--p-green-600);
      }
    }

    .dark {
      .p-card {
        border: 1px solid var(--p-green-300);
        text-align: start;

        .p-card-title {
          color: var(--p-green-200);
        }
      }
    }
  `,
};
